export default {

// TOP SECTION

    title: `Carte blanche to Tiina Itkonen`,
    subTitle: `Futurama`,

    intro: `The Finnish photographer has been documenting the Inuit communities and landscapes of Northern Greenland for more than twenty years. She photographs the lives of subsistence hunters and their families, and how they are affected by an increasingly sedentary existence and climate change. <br/><a href="http://tiinaitkonen.com/" target="_blank">Discover her work.</a>`,

};

